<template>
  <div class="ActivityDiscount">
    <div class='titlebg'>
      <img  class="bg" :src="imgUrl1" alt=""  >
      <!-- <img  class="bg" :src="imgUrl2" alt=""  >
      <img  class="bg" :src="imgUrl3" alt=""  >
      <img  class="bg" :src="imgUrl4" alt=""  >
      <div class="btns">一键领取</div> -->
    </div>
    <div class="btn btn1">
      <div @click="getActivityDiscount(2)"></div>
    </div>
    <!-- <div class="btn btn2">
      <div @click="getActivityDiscount(2)"></div>
    </div> -->
  </div>
</template>

<script>
import { orderSource } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'dragon',
  data(){
    return {
      imgUrl1: 'https://cms.dafang24.com/aliapp/20191012/dragon.jpg',
      // imgUrl2: 'https://cms.dafang24.com/aliapp/20191012/contentTwo.png',
      // imgUrl3: 'https://cms.dafang24.com/aliapp/20191012/contentThr.png',
      // imgUrl4: 'https://cms.dafang24.com/aliapp/20191012/contentFor.png',
      couponList2: [
        {
          name: "租三天，立减60元",
          OfferID: 290
        },
        {
          name: "租四天，立减100元",
          OfferID: 289
        }
      ],
    }
  },
  created () {},
  mounted () {},
  methods: {
    getActivityDiscount(type=0){
      if( localStorage.getItem('token') ){
        let couponList = this.couponList;
        if(type==1) { couponList = this.couponList1; }
        if(type==2) { couponList = this.couponList2; }
        this.consumerCouponsFn(couponList);
      } else {
        this.flexible.showToast({
            content: '请登录/注册！',
            duration: 1200,
            success: ()=>{
               //console.log('调用原生方法跳转登录');
              if( orderSource==17 ){
                window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
              } else if ( orderSource==16 ){
                dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
              }
            }
          });
      }
    },
    goHome () {
      if( orderSource==17 ){
        window.webkit.messageHandlers.goHome.postMessage(null);
      } else if ( orderSource==16 ){
        dfpanda.goHome();
      }
    },
    async consumerCouponsFn (copList) { // 获取用户优惠券
      let res = await getConsumerCoupons();
      if( res.Code==100 ){
        let uCoupon = res.Data || [];
        if( uCoupon.length ){
          for( let i in uCoupon ){
            for( let j in copList ){
              if( uCoupon[i].OfferID == copList[j].OfferID ){
                copList.splice(j, 1)
              }
            }
          }
        }
        console.log(copList);
        if( copList.length ){
          let lastRes = false;
          for( let item of copList ){
            let gRes = await this.getDrawCoupon(item.OfferID);
            if( gRes ){ lastRes = gRes }
          }
          if( lastRes ){
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！去租车',
              success:()=>{
                this.goHome()
              }
            });
          } else {
            this.flexible.showToast({content:'领取失败，请重试'})
          }
        } else {
          this.flexible.showToast({
            duration:1200,
            content:'领取成功！去租车',
            success:()=>{
              this.goHome()
            }
          })
        }
      }
    },
    async getDrawCoupon ( offerID ) {
      let res = await DrawCoupon({
        data: {
          OfferID: offerID,
          orgID: 0
        },
        isLoading: 1,
        loadContent: '获取优惠券...'
      });
      if( res.Code==100 ){
        return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      div {
        display: inline-block;
        /*background-color: rgba(0,0,0, .5);*/
      }
    }
    .btn1 {
      top: 1330px;
      div {
        width: 400px;
        height: 120px;
      }
    }
    .btn2  {
      top: 2760px;
      div {
        width: 600px;
        height: 120px;
      }
    }
  }
  .titlebg{
        position: relative;
    }        
  .titlebg .bg{
        width:100%;
        height:100%;
    }   
  .titlebg .btns{
        position: absolute;
        top:1670px;
        left:220px;
        width:300px;
        height:70px;
        background:rgba(255,250,186,1);
        opacity:1;
        border-radius:36px;
        line-height: 70px;
        text-align: center;
        font-size:25px;
        color:rgba(4,108,102,1);
    } 
    
</style>